import { IConnectionDrawingOptions } from '..';
import {
	ProjectState,
	ActionDescriptorState,
	OperationState,
	ChangeSet,
	ChangeSetEntityChangeType,
} from '@elyx-code/project-logic-tree';
import { connectPassthroughCallable } from './utils';

export function createOperationFromActionDescriptor(
	from: ActionDescriptorState,
	connectionOptions: IConnectionDrawingOptions,
	project: ProjectState,
	changeSet: ChangeSet
): OperationState {
	// Create a new function-declaration that implements the abstract entity
	const newOperation = from.implementAsOperation(changeSet);

	changeSet.add(newOperation, ChangeSetEntityChangeType.Added);

	connectPassthroughCallable(
		newOperation,
		connectionOptions,
		project,
		changeSet
	);

	return newOperation;
}
